var path = '/static/assets/khapps/khchart/generic/GerenericChart.html';
var html = "<highchart id=\"chart\" config=\"chartConfiguration\"></highchart>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;